import {getGuid, NativeId} from '@packages/systems/core/utils/NativeIdUtils';
import {Plugins, Component, Expressions} from '@packages/systems/wfdl';
import {ExpressionElement} from '@packages/systems/wfdl-ast';
import {Qualified} from '@packages/systems/wfdl-Qualified';
import {findSlotDefaultElement} from '@packages/systems/component-slots';

export function getElementAndComponentTypeByRendererNativeIdPath(
  elementId: string,
  rendererNativeIdPath: NativeId[],
  rootComponentType: Qualified<Component.ComponentName>,
  componentMap: Component.ComponentMap
): null | {
  element: ExpressionElement;
  componentType: Plugins.QualifiedElement;
} {
  const rootComponent = componentMap.get(rootComponentType);

  if (!rootComponent) {
    return null;
  }

  let component = rootComponent;
  let componentType = rootComponentType;

  for (const instanceNativeId of rendererNativeIdPath) {
    const instanceId = getGuid(instanceNativeId);
    // Slot defaults render nested inside the owning instance but live on the
    // definition's `defaultData`, so a render-only walk cannot follow the path
    // the renderer just took through them.
    const instance =
      Expressions.getElementById(Component.getRender(component), instanceId) ??
      findSlotDefaultElement(null, componentMap, componentType, instanceId)
        ?.element;
    if (!instance) {
      return null;
    }
    const nextComponent = componentMap.get(instance.type);
    if (!nextComponent) {
      return null;
    }
    componentType = instance.type;
    component = nextComponent;
  }

  const element =
    Expressions.getElementById(Component.getRender(component), elementId) ??
    findSlotDefaultElement(null, componentMap, componentType, elementId)
      ?.element;

  if (!element) {
    return null;
  }

  return {element, componentType};
}
